const TYPE = 'ps.Analytics'

function create() {
  return {
    type : TYPE
  }
}
export default {
  TYPE,
  create
}
